import { ApolloLink, Observable } from 'apollo-link';

export const subscribeOnRequest = store =>
  new ApolloLink((operation, forward) => {
    store.onRequest({ operation });
    const subscriber = forward(operation);
    return new Observable(observer => {
      let isPending = true;

      const subscription = subscriber.subscribe({
        next: result => {
          isPending = false;
          if (result.errors) {
            store.onError({ operation, graphQLErrors: result.errors });
          } else {
            store.onSuccess({ operation, result });
          }
          observer.next(result);
        },
        error: networkError => {
          isPending = false;
          store.onError({ operation, networkError });
          observer.error(networkError);
        },
        complete: observer.complete.bind(observer),
      });

      return () => {
        if (isPending) store.onCancel({ operation });
        if (subscription) subscription.unsubscribe();
      };
    });
  });
